import { ServicesContainer } from '@/services';
import { BagClickEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, InteractionTrackingType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { ProductListItem } from '../classes/product-list-item';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeBagClickEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LinkClicked;

  constructor(event: BagClickEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    if (event.meals) {
      this.productListItems = ProductListItem.getProductListItems(event.meals, store, services.order.isDelivery(), event.orderPath);
    }

    const order = services.order.getCurrentOrder();
    this.commerce[event.bagEventType] = { value: 1 };

    if (event.bagEventType === InteractionTrackingType.OrderNowClicks) {
      this.web.webInteraction = {
        linkClicks: { value: 1 },
        name: event.bagEventType,
        linkModuleName: `Bag|${event.bagEventType}`,
      }
      this.commerce.orderSubmitClick = { value: 1 };
    }

    if (event.bagEventType === InteractionTrackingType.OrderDuplications) {
      this.commerce.orderPath = event.orderPath;
      this.commerce.orderPathCount = { value: 1 };
    }

    if (order?.order.groupOrderId) {
      this.commerce.groupOrderCompleted = { value: 1 };
    }
  }
}
